<template>
  <div>
    <base-button icon round type="primary" class="mt-0" @click="modal = true">
      <span class="mdi mdi_icon mdi-24px mdi-account-credit-card-outline"/>
    </base-button>

    <modal id="createSystemAccount"
           :show.sync="modal"
           modal-classes="modal-dialog-centered modal-lg"
           showClose @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('system_account.modifyToken.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-2">
          <small>{{ $t('system_account.modifyToken.helpText') }}</small>
        </div>

        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>

        <form role="form" v-on:submit.prevent="create()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.tokenDetails.card_public_id') }}</label>
            <div class="col">
              <base-input
                name="card_public_id"
                v-model="token_card_details.card_public_id"
              >
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('system_account.tokenDetails.card_internal_id') }}</label>
            <div class="col">
              <base-input
                name="card_internal_id"
                v-model="token_card_details.card_internal_id"
              >
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              :loading="loading"
              type="primary"
              class="my-4"
              @click="validate()"
            >{{ $t('system_account.modifyToken.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal, TagsInput} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'modify-system-account-token',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    TagsInput,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      token_card_details: {
        card_public_id: '',
        card_internal_id: '',
      },
      modelValidations: {},
    }
  },
  computed: {
    ...mapState({
      loading: state => state.system_account.updating,
      error: state => state.system_account.error,
      system_account: state => state.system_account.single
    }),
    getActionErrorDetails() {
      return this.error
    }
  },
  methods: {
    ...mapActions(['UpdateSystemAccountToken']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.modify()
        }
      });
    },
    modify: function () {
      this.alert = false;
      this.UpdateSystemAccountToken({id: this.system_account.id, data: this.token_card_details}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('system_account.modifyToken.modifiedNotification', {username: this.system_account.username}),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          // closing dialog
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      this.modal = false;
      this.alert = false;
      // resetting form
      this.token_card_details = {
        card_public_id: '',
        card_internal_id: '',
      }

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
